import { createNamespacedHelpers } from 'vuex';
const { mapState: mapStateSystem } = createNamespacedHelpers('system');

import OnboardingTrialApi from 'api/onboarding/trial/onboardingTrial';
import TextInput from 'vcomponents/inputs/TextInput.vue';
import TelInput from 'vue-tel-input';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import {
    generalConditionsPath,
    privacyPolicyPath,
    getGoSellsyUrl,
} from 'Config/authenticated/goSellsyPaths';

const finalizeStatus = Object.freeze({
    SUCCESS: 'success',
    WARNING: 'alreadyExist',
    ERROR: 'error',
});

export default {
    components: {
        TextInput,
        TelInput,
        Preloader,
    },
    data() {
        return {
            loading: false,
            jobs: [
                {
                    label: this.$l10n.__('Dirigeant'),
                    id: -1,
                },
                {
                    label: this.$l10n.__('Directeur(trice) commercial(e)'),
                    id: -2,
                },
                {
                    label: this.$l10n.__('Directeur(trice) marketing'),
                    id: -3,
                },
                {
                    label: this.$l10n.__('Directeur(trice) financier(ière)'),
                    id: -4,
                },
                {
                    label: this.$l10n.__('Commercial(e)'),
                    id: -5,
                },
                {
                    label: this.$l10n.__('Administrateur(trice) des ventes'),
                    id: -6,
                },
                {
                    label: this.$l10n.__('Responsable service client'),
                    id: -7,
                },
                {
                    label: this.$l10n.__('Marketing'),
                    id: -8,
                },
                {
                    label: this.$l10n.__('Comptable'),
                    id: -9,
                },
                {
                    label: this.$l10n.__('Autre'),
                    id: -10,
                },
            ],
        };
    },
    created() {
        this.updateUtms(this.$route.query);
    },
    computed: {
        ...mapStateSystem(['reCaptchav3']),
        termsLabelLegalInformation() {
            return this.$l10n.__(
                `En cliquant sur « Créer mon compte », 
                vous acceptez les %(startLink)s Conditions Générales d\'Utilisation%(endLink)s. 
                Vous pouvez également consulter notre %(startPolicyLink)s Politique de confidentialité %(endLink)s`,
                {
                    startLink: `<a target='_blank' class='fs-3 semibold hover-primary-100' href='${getGoSellsyUrl(
                        this.legalInformationLang,
                        generalConditionsPath,
                    )}'>`,
                    endLink: `</a>`,
                    startPolicyLink: `<a target='_blank' class='fs-3 semibold hover-primary-100' href='${getGoSellsyUrl(
                        this.legalInformationLang,
                        privacyPolicyPath,
                    )}'>`,
                },
            );
        },
        legalsTerms() {
            return this.$l10n.__(
                `<i>Les données que vous nous fournissez sont traitées par les services clients et marketing de Sellsy aux fins de :</i>
                <br>
                - traiter vos demandes, vous permettre d’accéder à nos ressources en ligne, et d’utiliser notre Logiciel
                <br>
                - vous envoyer des offres commerciales et marketing
                <br> 
                <i>Pour en savoir plus, consultez notre %(policyStartLink)s politique de confidentialité %(policyEndLink)s.
                Vous pouvez à tout moment demander, selon les cas, l’accès, la rectification, la limitation,
                l’effacement de vos données, leur portabilité, ou vous opposer au traitement de vos données
                à des fins de prospection en cochant la case prévue à cet effet. Pour exercer ces droits,
                contactez notre DPO à l’adresse <a class='typographies-paragraph-small-semibold' href="mailto:dpo@sellsy.com">dpo@sellsy.com</a>.</i>`,
                {
                    policyStartLink: `<a target='_blank' class='typographies-paragraph-small-semibold' href='${getGoSellsyUrl(
                        this.legalInformationLang,
                        privacyPolicyPath,
                    )}'>`,
                    policyEndLink: `</a>`,
                    rightsStartLink: `<a target='_blank' class='typographies-paragraph-small-semibold' href="https://www.cnil.fr/fr/les-droits-pour-maitriser-vos-donnees-personnelles">`,
                },
            );
        },
        otherJobEnable() {
            return this.form.job === -10;
        },
    },
    methods: {
        /**
         * on validate event of tel input,
         * if is not valid value set field to error
         * else set field to success
         */
        onValidateTelInput({ isValid }) {
            this.isValidPhone = isValid;

            const phoneNumber = this.$refs.form.fields.find(({ prop }) => prop === 'phone_number');

            if (phoneNumber) {
                if (!isValid) {
                    phoneNumber.validateState = 'error';
                    phoneNumber.validateMessage = this.rules.phone_number[0].message;
                } else {
                    phoneNumber.validateState = 'success';
                    phoneNumber.validateMessage = undefined;
                }
            }
        },
        /**
         * On blur event of tel input,
         * if is not valid phone call onValidateTelInput
         * (examle case : user focus input and blur without value or with wrong value)
         */
        onBlurTelInput() {
            if (!this.isValidPhone) this.onValidateTelInput({ isValid: this.isValidPhone });
        },
        async getTokenReCaptchaV3(action) {
            if (this.reCaptchav3.isEnabled) {
                await this.$recaptchaLoaded();
                return await this.$recaptcha(action);
            } else {
                return 'undefined';
            }
        },
        /**
         * Signup with Account
         */
        async signup() {
            this.loading = true;

            const token = await this.getTokenReCaptchaV3('onboardingTrialValidate');
            this.form['g-recaptcha'] = token;

            OnboardingTrialApi.validateStep(this.form, 'validate', {
                'g-recaptcha-response': token,
                db: this.$route.query.db,
            })
                .then(
                    (response) => {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: 'gtm.formsubmit',
                            formId: this.form,
                        });

                        this.goToFinalPage(response);
                    },
                    (error) => {
                        Push.error(
                            this.$l10n.__("Une erreur est survenue lors de l'enregistrement"),
                            false,
                        );
                        this.errors.setErrors(error);
                    },
                )
                .finally(() => (this.loading = false));
        },
        updateUtms({ utm_source, utm_medium, utm_campaign, keyword, gclid }) {
            this.form.utm_source = utm_source;
            this.form.utm_medium = utm_medium;
            this.form.utm_campaign = utm_campaign;
            this.form.utm_keyword = keyword;
            this.form.utm_gclid = gclid;
        },

        /**
         * According to the status, redirect to the good route
         *
         * @param {Object} response - success response of onboarding
         */
        goToFinalPage(response) {
            switch (response.status) {
                // QuickTrial final page with waiting activation animation
                case finalizeStatus.SUCCESS:
                    this.$router.push({
                        name: 'onboarding.quicktrial.final',
                        params: {
                            response,
                        },
                    });
                    break;
                // Trial Classic page with Notification message
                case finalizeStatus.WARNING:
                    this.$router.push({
                        name: 'onboarding.trial.final',
                        params: {
                            response,
                            title: this.$l10n.__(
                                'Votre demande a été envoyé à notre équipe commerciale',
                            ),
                            description: this.$l10n.__(
                                'Nous avons bien reçu votre demande, un commercial vous recontactera dans les plus brefs délais.',
                            ),
                        },
                    });
                    break;
                // Trial Classic page with error message
                case finalizeStatus.ERROR:
                    this.$router.push({
                        name: 'onboarding.trial.final',
                        params: {
                            response,
                            title: this.$l10n.__(
                                'Une erreur est survenue lors de la création de votre compte',
                            ),
                            description: `
                            <p class='mb-2'>${this.$l10n.__(
                                'Notre équipe a été prévenu de ce problème. Nous vous invitons à relancer la création de votre compte d’ici quelques minutes.',
                            )}</p>
                            <p class='m-0'>${this.$l10n.__(
                                'Si le problème persiste, vous pouvez nous contacter sur l’adresse email : contact@sellsy.com',
                            )}</p>
                        `,
                        },
                    });
                    break;
                default:
                    break;
            }
        },
    },
};
